module.exports = __webpack_public_path__ + "img/1ffe4e3f72b685531cb48902f50373dd.png";